/**
 * Created by jsroads on 2021/8/30.5:46 下午
 * Note:
 */
// import {cc._decorator, Component,cc.Node, cc.CCInteger, cc.EventHandler, cc.EventTouch, UITransform, v2, v3, cc.CCFloat} from 'cc';
const { ccclass, property, menu } = cc._decorator;
export enum EventType {
    SCROLL_START,
    SCROLL_ING,
    SCROLL_END
}

enum SlideType {
    横向,
    纵向
}
@ccclass
@menu("自定义组件/循环滑动组件")
export class UIScrollSelect extends cc.Component {
    public static EventType = EventType;
    @property(cc.Node)
    content: cc.Node = null;

    @property({ type: cc.Enum(SlideType), tooltip: "滑动方向" })
    slideType: SlideType = SlideType.横向;


    @property({
        type: cc.Integer,
        tooltip: '单个控件之间的距离',
        visible() {
            return this.slideType == SlideType.横向
        }
    })
    deltaX: number = 100 //x间隔距离

    @property({
        type: cc.Integer,
        tooltip: '单个控件之间的距离',
        visible() {
            return this.slideType == SlideType.纵向
        }
    })
    deltaY: number = 100 //y间隔距离
    @property({
        type: cc.Float,
        tooltip: '中心点的缩放比例'
    })
    centerScale: number = 1.0
    @property({
        type: cc.Float,
        tooltip: '边缘点的缩放比例'
    })
    minScale: number = 1.0
    @property({
        type: cc.Float,
        tooltip: '滚动时的速度'
    })
    scrollSpeed: number = 300;
    @property({
        type: cc.Component.EventHandler,
        tooltip: "选择后的回调"
    })
    selectEvents: Array<cc.Component.EventHandler> = [];

    private isTouching: boolean = false;
    private hasTouchMove: boolean = false;
    private isTestX: boolean = false;
    private _touchId: any = null;
    private currentIndex: number = 0;
    private _toMoveX: number = 1; //移动方向
    private dx: number = 0;
    private moveAim: number = 0;

    onLoad() {
        if (this.slideType == SlideType.横向) {
            for (let i = 0; i < this.content.children.length; i++) {
                // this.content.children[i] = this.content.children[i];
                this.content.children[i].position = cc.v3(this.deltaX * (i - 1), this.content.children[i].position.y, 0)
            }
        } else {
            for (let i = 0; i < this.content.children.length; i++) {
                // this.content.children[i] = this.content.children[i];
                this.content.children[i].position = cc.v3(this.content.children[i].position.x, this.deltaY * (i - 1), 0)
            }
        }
        this.isTouching = false
        this.hasTouchMove = false
        this.isTestX = false;
        this._touchId = null;
        // this.currentIndex = 0;
        this.scrollTo(0, false);
    }
    /** 滚动到指定节点
     * @param idx
     * @param anim 是否带移动动画
     */
    scrollTo(idx: number, anim: boolean = true) {
        if (idx < 0 && idx >= this.content.children.length) {
            return console.error(this.node.name + '->移动超出边界面')
        }
        this.currentIndex = idx;
        this.moveAim = idx;
        if (!anim) {
            for (let i = 0; i < this.content.children.length; i++) {
                this.slideType == SlideType.横向 ? this._checkChildX(this.content.children[i], (i - idx) * this.deltaX, i)
                    : this._checkChildY(this.content.children[i], (i - idx) * this.deltaY, i,false)
            }
        } else {
            this.isTestX = true
            // cc.Component.EventHandler.emitEvents(this.selectEvents, {
            //     target: this,
            //     type: EventType.SCROLL_START,
            //     index: this.currentIndex
            // });
        }
    }
    /** 向左滚一个点 */
    scrollToLeft() {
        this._toMoveX = 1
        this.scrollTo((this.currentIndex - 1 + this.content.children.length) % this.content.children.length)
    }

    /** 向左滚一个点 */
    scrollToRight() {
        this._toMoveX = -1
        this.scrollTo((this.currentIndex + 1 + this.content.children.length) % this.content.children.length)
    }

    _checkChildX(child: cc.Node, x: number, index: number) {
        if (x > this.content.children.length / 2 * this.deltaX) {
            x -= this.content.children.length * this.deltaX
        } else if (x < -this.content.children.length / 2 * this.deltaX) {
            x += this.content.children.length * this.deltaX
        }
        child.position = cc.v3(x, child.position.y, child.position.z)
        let dx = Math.min(Math.abs(x), 3 * this.deltaX)
        let scale: number = (1 - dx / (3 * this.deltaX)) * (this.centerScale - this.minScale) + this.minScale
        child.scale = scale
    }
    _checkChildY(child: cc.Node, y: number, index: number,istouch:boolean) {
        if (y > this.content.children.length / 2 * this.deltaY) {
            y -= this.content.children.length * this.deltaY
        } else if (y < -this.content.children.length / 2 * this.deltaY) {
            y += this.content.children.length * this.deltaY
        }
        let lastY = child.y
        child.position = cc.v3(child.position.x, y, child.position.z)
        let dx = Math.min(Math.abs(y), 3 * this.deltaY)
        let scale: number = (1 - dx / (3 * this.deltaY)) * (this.centerScale - this.minScale) + this.minScale
        child.scaleX = scale
        // child.scaleY = scale
        child.opacity = (((scale- this.minScale)/(1-this.minScale))*0.85+0.15)*255;//cc.color(255 * (1 - scale - this.minScale), 255 * (1 - scale - this.minScale), 255 * (1 - scale - this.minScale), 255)
        // if (scale < 0.7) {
            child.scaleY = scale*scale
        // }
        if (Math.abs(y) < child.width / 2 && lastY * child.y <= 0 && this.nowChooseIndex != index) {
            this.nowChooseIndex = index
            // console.error("跨过了中心点", lastY, child.y, scale, child.getComponent(cc.Label).string)

            let distanceAry:number[] = [];

            for (let i = 0; i < this.content.children.length; i++) {
                let node:cc.Node = this.content.children[i];
                let parent:cc.Node = this.content.parent;
                let targetPos:cc.Vec2 = parent.convertToWorldSpaceAR(cc.v2(0,0));
                let distance:number = targetPos.sub(node.convertToWorldSpaceAR(cc.v2())).mag();
                distanceAry.push(distance);
            }

            let minDistance:number = Math.min(...distanceAry);
            let minIndex:number = distanceAry.indexOf(minDistance);
            if(minIndex > -1){
                this.nowChooseIndex = minIndex;
            }
            
            cc.Component.EventHandler.emitEvents(this.selectEvents, {
                target: this,
                touch:istouch,
                index: this.nowChooseIndex
            });
        }
    }
    nowChooseIndex: number = null
    start() {
        this.content.on(cc.Node.EventType.TOUCH_START, this._onTouch, this);
        this.content.on(cc.Node.EventType.TOUCH_MOVE, this._onTouch, this);
        this.content.on(cc.Node.EventType.TOUCH_END, this._onTouchEnd, this);
        this.content.on(cc.Node.EventType.TOUCH_CANCEL, this._onTouchEnd, this);
    }
    _onTouch(event: cc.Event.EventTouch) {
        if (this._touchId != null && event.touch != this._touchId) {
            return;
        }
        if (event.type == cc.Node.EventType.TOUCH_START) {
            this.isTouching = true;
            this.hasTouchMove = false
            this.isTestX = false;
            this._touchId = event.touch;
            this.dx = this.slideType == SlideType.横向 ? event.getStartLocation().x : event.getStartLocation().y
            // let evt = {
            //     target: this,
            //     type: EventType.SCROLL_START,
            //     index: this.currentIndex
            // }
            // cc.Component.EventHandler.emitEvents(this.selectEvents, evt);
            return;
        }
        this.hasTouchMove = true;
        let dx = (this.slideType == SlideType.横向 ? event.getLocation().x : event.getLocation().y) - this.dx

        this._move(dx);
        this.dx = this.slideType == SlideType.横向 ? event.getLocation().x : event.getLocation().y
        // let evt = {
        //     target: this,
        //     type: EventType.SCROLL_ING,
        //     dx: this.dx
        // }
        // cc.Component.EventHandler.emitEvents(this.selectEvents, evt);
    }
    _onTouchEnd(event: cc.Event.EventTouch) {
        if (this._touchId != null && event.touch != this._touchId) {
            return;
        }
        this.isTouching = false;
        if (event.type == cc.Node.EventType.TOUCH_END || event.type == cc.Node.EventType.TOUCH_CANCEL) {
            this._touchId = null;
        }
        // let tf = this.node.getComponent(UITransform)
        let lo = this.node.convertToNodeSpaceAR(event.getLocation())
        if (!this.hasTouchMove) {

            let mx = this.slideType == SlideType.横向 ? Math.ceil((lo.x - this.deltaX / 2) / this.deltaX) : Math.ceil((lo.y - this.deltaY / 2) / this.deltaY)
            if (mx === 0) {
                // let event1 = {
                //     target: this,
                //     type: EventType.SCROLL_END,
                //     index: this.currentIndex
                // }
                // cc.Component.EventHandler.emitEvents(this.selectEvents, event1);
                // console.error("滑动结束")
            } else {
                this.moveAim = (this.currentIndex + mx + this.content.children.length) % this.content.children.length
                this._toMoveX = mx > 0 ? -1 : 1
                this.isTestX = true;
            }
            return;
        }
        let max = this.deltaX;
        let minidx = 0
        for (let i = 0; i < this.content.children.length; i++) {
            let delta = this.slideType == SlideType.横向 ? Math.abs(this.content.children[i].position.x) : Math.abs(this.content.children[i].position.y)
            if (delta <= max) {
                max = delta
                minidx = i;
            }
        }
        this.moveAim = minidx
        this._toMoveX = (this.slideType == SlideType.横向 ? this.content.children[minidx].position.x : this.content.children[minidx].position.y) >= 0 ? -1 : 1
        this.isTestX = true;
    }
    _move(dt: number) {
        for (let i = 0; i < this.content.children.length; i++) {
            this.slideType == SlideType.横向 ? this._checkChildX(this.content.children[i], this.content.children[i].position.x + dt, i)
                : this._checkChildY(this.content.children[i], this.content.children[i].position.y + dt, i,true)
        }
    }


    update(dt: number) {
        if (this.isTouching || !this.isTestX) {
            return;
        }
        let stepx = this._toMoveX * dt * this.scrollSpeed
        let ly = this.content.children[this.moveAim].position.y
        let lx = this.content.children[this.moveAim].position.x
        for (let i = 0; i < this.content.children.length; i++) {
            this.slideType == SlideType.横向 ? this._checkChildX(this.content.children[i], this.content.children[i].position.x + stepx, i)
                : this._checkChildY(this.content.children[i], this.content.children[i].position.y + stepx, i,true)
        }
        if (this.slideType == SlideType.横向) {
            let x = this.content.children[0].position.x;
            let idx = Math.round(x / this.deltaX);
            let tox = this.deltaX * idx;
            let cx = this.content.children[this.moveAim].position.x
            if (lx * cx < 0 && Math.abs(cx) < this.deltaX) {
                this.isTestX = false;
                for (let i = 0; i < this.content.children.length; i++) {
                    if (Math.abs(this.content.children[i].position.x) <= Math.abs(stepx)) {
                        this.currentIndex = i;
                        break;
                    }
                }
                for (let i = 0; i < this.content.children.length; i++) {
                    this._checkChildX(this.content.children[i], this.content.children[i].position.x + tox - x, i)
                }
                // let event = {
                //     target: this,
                //     type: EventType.SCROLL_END,
                //     index: this.currentIndex
                // }
                // cc.Component.EventHandler.emitEvents(this.selectEvents, event);
            }
        } else {
            let y = this.content.children[0].position.y;
            let idy = Math.round(y / this.deltaY);
            let toy = this.deltaY * idy;
            let cy = this.content.children[this.moveAim].position.y
            if (ly * cy < 0 && Math.abs(cy) < this.deltaY) {
                this.isTestX = false;
                for (let i = 0; i < this.content.children.length; i++) {
                    if (Math.abs(this.content.children[i].position.y) <= Math.abs(stepx)) {
                        this.currentIndex = i;
                        break;
                    }
                }
                for (let i = 0; i < this.content.children.length; i++) {
                    this._checkChildY(this.content.children[i], this.content.children[i].position.y + toy - y, i,true)
                }
                // let event = {
                //     target: this,
                //     type: EventType.SCROLL_END,
                //     index: this.currentIndex
                // }
                // cc.Component.EventHandler.emitEvents(this.selectEvents, event);
                // console.error("滑动结束1")
            }
        }
    }
}
